import React from "react";
import ErrorMessage from "../ErrorMessage/ErrorMessage";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import IconButton from "@mui/material/IconButton";
import ClearIcon from "@mui/icons-material/Clear";
import Select from "../Select/Select";
import MenuItem from "../MenuItem/CustomMenuItem";

const findLabelByValue = (selectedValue, menuItems) => {
  const selectedMenuItem = menuItems.find(
    (menuItem) => String(menuItem.value) === String(selectedValue),
  );
  return selectedMenuItem ? selectedMenuItem.label : null;
};

const hasSelectedValue = (value) => {
  if (value === null || value === undefined) return false;
  if (value === "") return false;
  return true;
};

const SingleSelect = (props) => {
  const {
    id,
    name,
    tag,
    value,
    label,
    handleChange,
    onBlur,
    menuItems=[],
    errorMessage,
    disabled,
    clearable = false,
  } = props;
  const selectProps = {
    id,
    name,
    value,
    label,
  };
  const showClearButton =
    clearable && hasSelectedValue(value) && !disabled;

  const handleClear = (event) => {
    event.preventDefault();
    event.stopPropagation();
    if (!handleChange) return;
    handleChange({
      target: {
        name,
        value: "",
      },
    });
  };

  return (
    <FormControl sx={{ width: "100%" }}>
      <InputLabel
        sx={{ backgroundColor: "white", fontWeight: "400" }}
        id={id}
      >
        {tag}
      </InputLabel>
      <Select
        {...selectProps}
        multiline
        displayEmpty
        renderValue={(selected) => {
          const selectedLabel = findLabelByValue(selected, menuItems);
          if (!selected) {
            return <em>{selectedLabel}</em>;
          }
          return selectedLabel
        }}
        onChange={handleChange}
        onBlur={onBlur}
        disabled={disabled}
        endAdornment={
          showClearButton ? (
            <IconButton
              aria-label="Clear selection"
              size="small"
              onClick={handleClear}
              onMouseDown={(event) => {
                event.preventDefault();
                event.stopPropagation();
              }}
              sx={{ position: "absolute", right: 28 }}
            >
              <ClearIcon fontSize="small" />
            </IconButton>
          ) : null
        }
      >
        {menuItems.map((menuItem) => (
          <MenuItem
            key={menuItem.key}
            value={menuItem.value}
            disabled={menuItem.disabled}
          >
            {menuItem.label}
          </MenuItem>
        ))}
      </Select>
      {errorMessage ? <ErrorMessage>{errorMessage}</ErrorMessage> : null}
    </FormControl>
  );
};

export default SingleSelect;
